import { PlaceOnCianBanner } from 'shared/components/PlaceOnCianBanner';
import { FirstTimeBanner } from 'shared/components/SmbPage/FirstTimeBanner';
import { SobGuideArticleBanner } from 'shared/components/SobGuideArticleBanner';
import { TBannerType } from 'shared/types/banner';

export const renderBanner = (banner: TBannerType) => {
  switch (banner) {
    case 'firstTimeOnCian':
      return <FirstTimeBanner />;
    case 'placeOnCian':
      return <PlaceOnCianBanner />;
    case 'placeOnCianHost':
      return <PlaceOnCianBanner variant="host" />;
    case 'sobGuideArticle':
      return <SobGuideArticleBanner />;
    default:
      return null;
  }
};
